import { ActionContext, Store } from 'vuex'
import { fetchToftaUrl } from '@/services/variable.service'
import { Namespace } from '@/store'

export enum Properties {
  Loading = 'submitted',
  Exception = 'exception',
  ToftaUrl = 'toftaUrl',

  FetchVariables = 'fetchVariables'
}

interface State {
  [Properties.Loading]: boolean;
  [Properties.Exception]: boolean;
  [Properties.ToftaUrl]: string;
}

export type VuexActionContext = ActionContext<State, {}>

const namespace = (s: string): string => `${Namespace.Variable}/${s}`

export const getLoading = (store: Store<VuexActionContext>): boolean => store.getters[namespace(Properties.Loading)]
export const getException = (store: Store<VuexActionContext>): boolean => store.getters[namespace(Properties.Exception)]
export const getToftaUrl = (store: Store<VuexActionContext>): string => store.getters[namespace(Properties.ToftaUrl)]
export const fetchVariables = (store: Store<VuexActionContext>): Promise<void> => store.dispatch(namespace(Properties.FetchVariables))

const VariableStore = {
  namespaced: true,
  state: {
    [Properties.Loading]: false,
    [Properties.Exception]: false,
    [Properties.ToftaUrl]: null
  },
  getters: {
    [Properties.Loading]: (state: State) => state[Properties.Loading],
    [Properties.Exception]: (state: State) => state[Properties.Exception],
    [Properties.ToftaUrl]: (state: State) => state[Properties.ToftaUrl]
  },
  mutations: {
    [Properties.Loading]: (state: State, value: boolean) => {
      state[Properties.Loading] = value
    },
    [Properties.Exception]: (state: State, value: boolean) => {
      state[Properties.Exception] = value
    },
    [Properties.ToftaUrl]: (state: State, value: string) => {
      state[Properties.ToftaUrl] = value
    }
  },
  actions: {
    [Properties.FetchVariables]: async ({ commit }: ActionContext<State, {}>): Promise<void> => {
      try {
        commit(Properties.Loading, true)
        commit(Properties.Exception, false)
        const toftaUrl = await fetchToftaUrl()
        commit(Properties.ToftaUrl, toftaUrl)
      } catch (err) {
        commit(Properties.Exception, true)
      } finally {
        commit(Properties.Loading, false)
      }
    }
  }
}

export default VariableStore
